module.exports = __webpack_public_path__ + "static/media/visas.492b9820.png";